module.exports = __webpack_public_path__ + "img/41.0bb33b34.png";